var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.19 8.79H3.577a.29.29 0 0 0-.29.29v11.61c0 .16.13.29.29.29H7.19c.16 0 .29-.13.29-.29V9.08a.29.29 0 0 0-.29-.29ZM5.384 3.02A2.386 2.386 0 0 0 3 5.4a2.386 2.386 0 0 0 2.384 2.383 2.385 2.385 0 0 0 2.383-2.383A2.385 2.385 0 0 0 5.384 3.02ZM16.38 8.502c-1.45 0-2.523.624-3.174 1.333V9.08a.29.29 0 0 0-.29-.29h-3.46a.29.29 0 0 0-.291.29v11.608c0 .16.13.29.29.29h3.606c.16 0 .29-.13.29-.29v-5.743c0-1.936.526-2.69 1.875-2.69 1.47 0 1.586 1.21 1.586 2.79v5.644c0 .16.13.29.29.29h3.607c.16 0 .29-.13.29-.29v-6.368c0-2.878-.548-5.82-4.618-5.82Z"
  })));
};
export default SvgLinkedin;